module.exports = __webpack_public_path__ + "img/IMG_1231_L.6a79904e.webp";